import { createSelector } from 'reselect'

import { getApp } from '../../common/selectors'

export default createSelector([getApp], (app) => ({
  modals: app.modals,
}))
